import React from "react";
import {
  Link
} from "react-router-dom";
import { IconButton, Input, SelectPicker } from 'rsuite';
import PlusIcon from '@rsuite/icons/Plus';
import axios from 'axios';
import { addDays, subDays } from "date-fns";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withRouter from '../../WithRouter';
import Moment from 'react-moment';
import 'moment-timezone';
import moment from 'moment';

import { AiOutlineThunderbolt } from "react-icons/ai";
import { GiCartwheel } from "react-icons/gi";
import { GiSattelite } from "react-icons/gi";
import { RiBattery2ChargeLine } from "react-icons/ri";
import ReloadIcon from '@rsuite/icons/Reload';
import { etollSentStatusRecords, etollSentCheckDevice, etollSentStatusSummary } from '../../actions/EtollSentRecordsStatus';



class DisplayEtollSentRecords extends React.Component {
  constructor(props) {
  super(props);
    this.state = {
      sentRecordsList: [],
      sentRecordsSumm: [],
      sentRecordsCheckDevice: [],
      etollCheckImei: '',
      // integrationsEtoll: [],
    };
    this.refreshSummary = this.refreshSummary.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleEtollCheckImeiSubmit = this.handleEtollCheckImeiSubmit.bind(this);
  }

  componentDidMount() {
    const params = {
    }
    this.props.etollSentStatusRecords(params, this.props.history);
    this.props.etollSentStatusSummary(params, this.props.history);

    this.timeout = setInterval(() => {
        console.log('sentRecordsCheckDevice')
        console.log(this.state.sentRecordsCheckDevice)
        const params = {
        }
        this.props.etollSentStatusRecords(params, this.props.history);
        this.props.etollSentStatusSummary(params, this.props.history);
    }, 10000)
  }

  componentDidUpdate(prevProps) {
    if(prevProps.etollsentstatuslist.list.data !== this.props.etollsentstatuslist.list.data) {
      this.setState({sentRecordsList: this.props.etollsentstatuslist.list.data});
    }
    if(prevProps.etollsentstatussummary.list.data !== this.props.etollsentstatussummary.list.data) {
      this.setState({sentRecordsSumm: this.props.etollsentstatussummary.list.data});
    }
    if(prevProps.etollsentstatuscheckdevice !== this.props.etollsentstatuscheckdevice) {
      this.setState({sentRecordsCheckDevice: this.props.etollsentstatuscheckdevice.list.data});
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.value;
    console.log(name, value);
    this.setState({
      [name]: value
    });
  }

  handleEtollCheckImeiSubmit(event) {
    event.preventDefault();
    const params = {
      imei: this.state.etollCheckImei
    }
    console.log('params', params)
    this.props.etollSentCheckDevice(params, this.props.history);
  };


  refreshSummary(d) {
    const params = {
    }
    this.props.etollSentStatusSummary(params, this.props.history);
  }

  render() {
    let sm = this.state.sentRecordsSumm;
    let last_rec_tmstp = 0;
    let last_snt_tmstp = 0;
    let rec_to_process_left = 0;
    let rec_to_process_redis = 0;
    if(sm.last_rec !== undefined) {
        last_rec_tmstp = sm.last_rec.timestamp;
        last_snt_tmstp = sm.last_snt.timestamp;
        rec_to_process_left = sm.records_to_process_left;
        rec_to_process_redis = sm.redis_rec_count;
    }


    let iet = this.state.sentRecordsCheckDevice;
    iet.forEach(function(obj){
      // console.log(obj)
      let sts = obj.value.sendToEtollTimestamp;
      let cts = Date.now();
      let tdiff = (cts-sts)/1000;
      let ign = obj.value.ignition;
      let mov = obj.value.movement;
      let sendstat = false;
      if(ign === 1 && mov === 1) {
        if(tdiff <= 120){
          sendstat = true;
        }
      } else {
        if(tdiff <= 900){
          sendstat = true;
        }
      }
      obj.dst = sendstat;
    });




    return (
      <div className="content-wrapper notifications integrations etoll-sent">
        <div className="content">
        <div className="content-left">

        <form name="odometeredit" onSubmit={this.handleEtollCheckImeiSubmit}>
          <label>
              Podaj IMEI:
              <input className="formImei" type="text" value={this.state.etollCheckImei} name="etollCheckImei" onChange={this.handleInputChange} />
          </label>
          <input type="submit" value="Wyślij" />
          </form>
        

          <h2>Wysyłka E-toll</h2>
          <ul>
            <li className='notification head'>
              <div className="vehicle-container">
                <div className="dot"></div>
                <div className="vehicle">
                  <div className="codename">
                    Nazwa
                  </div>
                  <div className="licenseplate">
                    IMEI
                  </div>
                </div>
                <div className="date-start">
                  <div className="label">
                    Ostatni rekord:
                  </div>
                </div>
                <div className="date-start">
                  <div className="label">
                    Ostatnia wysyłka do Etoll:
                  </div>
                </div>
                <div className="parameters">
                  <div className="label">
                    Parametry
                  </div>
                </div>
              </div>
            </li>
            {this.state.sentRecordsCheckDevice.map((integration, i) => (
              <li key={i} className='notification'>
                {integration.value === false ? (
                  <div className="vehicle-container">
                    <div className={`dot dot-${integration.dst ? 'green' : 'red'}`}></div>
                    <div className="vehicle">
                      <div className="codename">
                        {integration.imei}
                      </div>
                    </div>
                    <div className="date-start">
                      Brak danych
                    </div>
                  </div>
                  ) : (
                  <div className="vehicle-container">
                    <div className={`dot dot-${integration.dst ? 'green' : 'red'}`}></div>
                    <div className="vehicle">
                      <div className="codename">
                        {integration.value.codename}
                      </div>
                      <div className="licenseplate">
                        {integration.value.imei}
                      </div>
                    </div>
                    <div className="date-start">
                      <Moment format="DD.MM.YYYY HH:mm:ss">
                        {new Date(integration.value.recordTimestamp)}
                      </Moment>
                    </div>
                    <div className="date-start">
                      <Moment format="DD.MM.YYYY HH:mm:ss">
                        {new Date(integration.value.sendToEtollTimestamp)}
                      </Moment>
                    </div>
                    <div className="parameters">
                      <div className="par ignition">
                        <div className="label">
                          <AiOutlineThunderbolt />
                        </div>
                          {integration.value.ignition ? 'Wł' : 'Wył'}
                      </div>
                      <div className="par movement">
                        <div className="label">
                          <GiCartwheel />
                        </div>
                          {integration.value.movement ? 'Wł' : 'Wył'}
                      </div>
                      <div className="par satelites">
                        <div className="label">
                          <GiSattelite />
                        </div>
                          {integration.value.sat}
                      </div>
                      <div className="par voltage">
                        <div className="label">
                          <RiBattery2ChargeLine />
                        </div>
                          {(integration.value.voltage/1000).toFixed(2)}V
                      </div>
                    </div>
                  </div>
                )}
              </li>
            ))}
          </ul>







        
        </div>
        </div>
        
        <div className="content">
          <div className="content-left etoll-sent-hidden">
            {1 < sm.length
            ? (
                ''
            )
            : (
                <div className="summary-container"> 
                    <div className="group">
                        <div className="label">
                            Ostatni zapisany rekord:
                        </div>
                        <div className="value">
                            <Moment format="DD.MM.YYYY HH:mm:ss">
                                {new Date(last_rec_tmstp)}
                            </Moment>
                        </div>
                    </div>
                    <div className="group">
                        <div className="label">
                            Ostatni wysłany rekord:
                        </div>
                        <div className="value">
                            <Moment format="DD.MM.YYYY HH:mm:ss">
                                {new Date(last_snt_tmstp)}
                            </Moment>
                        </div>
                    </div>
                    <div className="group">
                        <div className="label">
                            Niewysłane rekordy w bazie:
                        </div>
                        <div className="value">
                            {rec_to_process_left}
                        </div>
                    </div>
                    <div className="group last">
                        <div className="label">
                            Rekordy oczekujące w Redis:
                        </div>
                        <div className="value">
                            {rec_to_process_redis}
                        </div>
                    </div>
                    <div className="group refresh">
                      <div className="but-cont">
                        <IconButton
                          icon={<ReloadIcon/>}
                          appearance="ghost"
                          circle size="sm"
                          onClick={ this.refreshSummary }/>
                      </div>
                    </div>
                </div>
                
            )}

          <ul className="etoll-sent-hidden">
            {this.state.sentRecordsList.map((el, i, elements) => (
              <li key={i} className='notification'>
                <div className="id">{el.id}</div>
                <div className="sent_timestamp">
                    <Moment format="DD.MM.YYYY HH:mm:ss">
                        {new Date(el.sent_timestamp)}
                    </Moment>
                </div>


                <div className="duration">
                    {i+1 === elements.length
                    ? (
                        ''
                    )
                    : (
                        <div> 
                            <Moment duration={new Date(elements[i+1].sent_timestamp)} date= {new Date(el.sent_timestamp)}  trim />    
                        </div>
                        
                    )}
                </div>
                <div className="record_count">{el.record_count}</div>
              </li>
            ))}
          </ul>

          </div>
        </div>
      </div>
    );
  }
}

DisplayEtollSentRecords.propTypes = {
    etollSentStatusRecords: PropTypes.func.isRequired,
    etollsentstatuscheckdevice: PropTypes.func.isRequired,
    etollSentStatusSummary: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    etollsentstatuslist: state.etollsentstatuslist,
    etollsentstatuscheckdevice: state.etollsentstatuscheckdevice,
    etollsentstatussummary: state.etollsentstatussummary,
    vehicles: state.vehicles,
    errors: state.errors
});

export default connect(mapStateToProps,{ etollSentStatusRecords, etollSentCheckDevice, etollSentStatusSummary })(withRouter(DisplayEtollSentRecords))
